// extracted by mini-css-extract-plugin
export default {"container":"TabelaMadeiras_container__j88cH","tabela":"TabelaMadeiras_tabela__KL1C6"};